// extracted by mini-css-extract-plugin
module.exports = {"logout":"logout-button_logout__14PFI","icon":"logout-button_icon__3R3at"};